import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Stale time: 5 minutes (as requested)
      // Data is considered fresh for 5 min, no refetch during this window
      staleTime: 5 * 60 * 1000, // 300,000ms

      // Garbage collection time: 10 minutes
      // Cache persists for instant back-navigation
      gcTime: 10 * 60 * 1000,

      // Retry failed requests with exponential backoff
      // Aligns with Phase 6 retry fixes
      retry: 2,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),

      // Refetch on window focus (helps keep data fresh)
      refetchOnWindowFocus: true,

      // Refetch on reconnect
      refetchOnReconnect: true,

      // Skip refetch on mount when data is still fresh (within staleTime window).
      // Data still refreshes on window focus, reconnect, and explicit invalidation.
      refetchOnMount: false,
    },
    mutations: {
      // Retry failed mutations once
      retry: 1,
      retryDelay: 1000,
    },
  },
});
